import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { SearchItemUnionProps, SearchType } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';

export interface ActionButtonContextContextData {
  item?: Maybe<SearchItemUnionProps>;
  setItem: Dispatch<SetStateAction<Maybe<SearchItemUnionProps>>>;
  // Search type for the record whose Action popover is currently open. Set by
  // ActionButton (which already knows People vs Company) so the shared action
  // dialogs/mutations use the record's type instead of the page route — e.g. a
  // person opened from the employees sidebar on a company page.
  searchTypeOverride?: Maybe<SearchType>;
  setSearchTypeOverride: Dispatch<SetStateAction<Maybe<SearchType>>>;
  processingItems?: Maybe<string[]>;
  addProcessingItems: (info: ProcessingItemInfo) => void;
  removeProcessingItems: (info: Omit<ProcessingItemInfo, 'state'>) => void;
  isItemProcessing: (info: Omit<ProcessingItemInfo, 'state'>) => boolean;
  getItemState: (
    info: Omit<ProcessingItemInfo, 'state'>
  ) => ProcessingItemState | undefined;
}

export interface ActionButtonContextContextProps extends PropsWithChildren {
  value?: ActionButtonContextContextData;
}

export interface ProcessingItemInfo {
  id: string;
  type: QUICK_INFO_BUTTONS | 'SAVING';
  state?: ProcessingItemState;
}

export enum ProcessingItemState {
  UNLOCKING = 'UNLOCKING',
  UPDATING = 'UPDATING',
  UPDATING_JOB_CHANGE = 'UPDATING_JOB_CHANGE',
  CHECKING_FOR_UPDATE = 'CHECKING_FOR_UPDATE',
  REVERIFYING = 'REVERIFYING',
}
